const API_DOMAIN = "https://d6lvprgrke.execute-api.us-east-1.amazonaws.com/dev";
// const API_DOMAIN = "http://localhost:5000/dev";

module.exports = {
  API_DOMAIN,
};
